import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
  selector: 'app-delete-profile-card',
  templateUrl: './delete-profile-card.component.html',
  styleUrl: './delete-profile-card.component.scss'
})
export class DeleteProfileCardComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      deleteTitle: string
      deleteDescription: string
      isSubscriptionPlanCancelPage: boolean
    },
  ) {
  }
}
